import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Layout from '../../components/layout';
import { navigate } from 'gatsby';
import { CardManagementModel } from '@dobredary-pl/card-config';
import CardManagementView from '../../components/card-management/CardManagementView';
import SEO from '../../components/SEO';

interface CardManagementProps {
  cardId: string;
}

const CardManagement = ({ cardId: id }: CardManagementProps) => {
  const [cards, setCards] = useState<CardManagementModel[] | null>(null);

  useEffect(() => {
    axios
      .get<{ result: CardManagementModel[] }>(
        `${process.env.API_URL}/orders/${id}`
      )
      .then(({ data }) => {
        setCards(data.result);
      })
      .catch(() => navigate('/404'));
  }, [id]);

  return (
    <Layout customSEO>
      <SEO title={'Zarządzanie kartką'} noIndex={true} />
      <div>
        <main>
          <CardManagementView cards={cards} />
        </main>
      </div>
    </Layout>
  );
};

export default CardManagement;
